/**
 * VIBE_CODING_STANDARD
 * 
 * -----
 * VERSION_HISTORY:
 * 1.0.0:gemini-1.5-flash (CURRENT) - Initial application of VIBE_CODING_STANDARD directives.
 *                                   - Integrated with `ErrorContext` for global error display.
 * 
 * -----
 * SECURITY_RISK: LOW - This component displays error messages.
 *                      It does not handle sensitive data or perform critical operations.
 * INTENT: Provide a centralized and consistent modal dialog for displaying global API errors
 *         to the user, improving error visibility and user feedback.
 * PROMPTER_INSTRUCTIONS: When modifying, ensure the modal is always accessible and
 *                        that error messages are clear and actionable for the user.
 * LLM_CONFIDENCE: 100% - Standard modal component for displaying messages.
 */
import React from 'react';
import { useError } from '../context/ErrorContext.tsx';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from './ui/dialog.tsx';
import { Button } from './ui/button.tsx';

const ErrorModal: React.FC = () => {
  const { globalErrorMessage, isGlobalErrorModalOpen, clearError } = useError();

  return (
    <Dialog open={isGlobalErrorModalOpen} onOpenChange={clearError}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="text-destructive">API Error</DialogTitle>
          <DialogDescription>
            An unexpected error occurred while communicating with the server.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4 text-red-600">
          {globalErrorMessage || 'Please try again later. If the problem persists, contact support.'}
        </div>
        <DialogFooter>
          <Button onClick={clearError}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ErrorModal;